import { render } from "./com-device-select.vue?vue&type=template&id=45de3126"
import script from "./com-device-select.vue?vue&type=script&lang=js"
export * from "./com-device-select.vue?vue&type=script&lang=js"
script.render = render

export default script